/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBusyContext = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M10 16v2h5.17a3.003 3.003 0 0 1 2.654-1.995L18 16a3 3 0 1 1-2.829 4H10v2H2v-6zm8 2a1 1 0 1 0 .001 2.001A1 1 0 0 0 18 18zM8 18H4v2h4zm-1-8v4H5v-4zm12 0v4h-2v-4zm3-8v6h-8V6H8.829a3.003 3.003 0 0 1-2.653 1.995L6 8a3 3 0 1 1 2.83-4H14V2zM6 4a1 1 0 1 0 .001 2.001A1 1 0 0 0 6 4zm14 0h-4v2h4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBusyContext as BusyContext };
